import { render } from "./Customers.vue?vue&type=template&id=1917ed3a"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"
script.render = render

export default script